"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Generic callback manager that stores callbacks and allows
 * to remove them or run them all.
 */
var CallbackManager = /** @class */ (function () {
    function CallbackManager() {
        this.callbacks = {};
    }
    CallbackManager.prototype.add = function (key, callback) {
        var _this = this;
        var arr = this.callbacks[key];
        if (!arr) {
            arr = [];
            this.callbacks[key] = arr;
        }
        arr.push(callback);
        return function () {
            _this.rm(key, callback);
        };
    };
    CallbackManager.prototype.rm = function (key, callback) {
        if (callback === void 0) { callback = null; }
        var arr = this.callbacks[key];
        if (!arr)
            return;
        if (callback === null) {
            arr.splice(0, arr.length);
            return;
        }
        for (var i = 0; i < arr.length; i++) {
            if (arr[i] === callback) {
                arr.splice(i, 1);
                return;
            }
        }
    };
    CallbackManager.prototype.rmAll = function () {
        for (var key in this.callbacks) {
            this.rm(key);
        }
    };
    CallbackManager.prototype.run = function (key) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        var arr = this.callbacks[key];
        if (!arr)
            return;
        arr.forEach(function (callback) { return callback.apply(void 0, args); });
    };
    return CallbackManager;
}());
exports.default = CallbackManager;
